import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import HistoryExportTable from './history-export-table.vue';
import { getPushDownloadHistory } from '@/api/creative/push';
import { loginSs } from '@/api/common';
import Pagination from '@/components/Pagination/index.vue';
import _ from 'lodash';
import { language } from '@/common/storage';

var _defaultQuery = {
  page: 1,
  page_size: 10,
  status: [],
  is_reduce: '',
  order: '-created_time'
};

export default {
  props: {
    config: {
      type: Object
    },
    handlePreview: [Function]
  },
  components: {
    Pagination: Pagination,
    HistoryExportTable: HistoryExportTable
  },
  data: function data() {
    return {
      query: _extends({}, _defaultQuery),
      pagination: {
        total: 1
      },
      channels: [],
      loading: false,
      list: [],
      allCount: 0,
      loginLoading: false
    };
  },

  methods: {
    handleSizeChange: function handleSizeChange(num) {
      this.query.page_size = num;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(num) {
      this.query.page = num;
      this.init();
    },
    handleLogin: function handleLogin() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.loginLoading) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _this.loginLoading = true;
                _context.prev = 3;
                _context.next = 6;
                return loginSs();

              case 6:
                res = _context.sent;
                url = _.get(res, 'data.data.redirect_url') + '&lang=' + (language.get() === 'en' ? 'en' : 'cn');

                window.open(url, '_blank');
                _this.loginLoading = false;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](3);

                console.log(_context.t0);
                _this.loginLoading = false;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 12]]);
      }))();
    },
    init: function init() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return _this2.$store.dispatch('config/getCommonConfig', {
                  names: ['channels']
                });

              case 3:
                res = _context2.sent;

                _this2.channels = _.get(res, 'channels');
                _this2.getList();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    resetQuery: function resetQuery() {
      this.query = _extends({}, _defaultQuery);
    },
    getList: function getList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return getPushDownloadHistory(_extends({}, _this3.query, {
                  status: _this3.query.status.join(','),
                  project_id: _this3.config.id,
                  mod: _this3.getMod(_this3.config.from)
                }));

              case 3:
                res = _context3.sent;

                _this3.loading = false;
                _this3.list = _.get(res, 'data.data.list') || [];
                _this3.pagination.total = _.get(res, 'data.data.total', 0);
                _this3.allCount = _.get(res, 'data.data.sum', 0);
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                _this3.loading = false;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    },
    getMod: function getMod(from) {
      if (from === 1) {
        return 'demand';
      } else if (from === 2) {
        return 'dmaker';
      } else if (from === 3) {
        return 'gmaker';
      } else if (from === 4) {
        return 'ps';
      }
      return 'ps';
    }
  },
  mounted: function mounted() {
    this.list = [];
    this.resetQuery();
    this.init();
  }
};